import React, { ReactNode, useEffect, useRef, useState } from "react"
import ReactDOM from "react-dom"
import { makeSentenceBreakList } from "utils/util"

type ToolTipType = {
  name: string
  position: [number, number]
  children?: ReactNode
}

export const ToolTip: React.FC<ToolTipType> = props => {
  const target = useRef<HTMLDivElement>()
  const [margin, setMargin] = useState<[number, number]>([0, 0])
  const parentDom = document.getElementsByTagName("body")
  const message = makeSentenceBreakList(props, "name")
  //多少の当たり判定
  useEffect(() => {
    if (!!target.current && !!props.position) {
      const windowHeight = window.innerHeight
      const windowWidth = window.innerWidth
      const rect = target.current.getBoundingClientRect()
      const position = { top: 0, left: 0 }
      if (windowWidth - 40 < rect.right)
        position.left = windowWidth - rect.right - 40
      if (windowHeight - 24 < rect.bottom) position.top = -(rect.height + 24)
      setMargin([position.top, position.left])
    } else {
      setMargin([0, 0])
    }
  }, [props.position])
  return !!props.name
    ? ReactDOM.createPortal(
        <div
          className="tooltip show"
          ref={target}
          style={{
            top: props.position[0] + margin[0],
            left: props.position[1] + margin[1],
          }}
        >
          {message.map((str, i) => (
            <div key={i}>{str}</div>
          ))}
          {props.children ? props.children : null}
        </div>,
        parentDom[0]
      )
    : null
}
